<template>
    <div class="row plain-element">
        <div v-if="!isLoggedIn()" class="dashboard-cards">
            <NoPermissionComponent/>
        </div>
        <div v-if="getUsername() && getSelectMenus()">
            <div class="modal fade" id="primarySelectionModal" tabindex="-1" aria-labelledby="primarySelectionModalLabel" aria-hidden="true">
                <div class="modal-dialog" style="max-width: 96%;">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="row plain-element" style="width: 100%;">
                                <div class="col col-12 col-sm-2">
                                    <div class="row plain-element">
                                        <div class="input-field  col col-12 col-sm-12 col-md-2 col-lg-2">
                                            <label class="label-search opp-abb-lg">Area:</label>
                                        </div>
                                        <div class="input-field  col col-12 col-sm-12 col-md-8 col-lg-8">
                                            <select v-model="area" name="area" id="area" @change="clearSearch()" class="modal-select">
                                                <option value="" selected> All Areas</option>
                                                <option v-for="(element, index) in getSelectMenus().areas" :key="index">
                                                    {{ element }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="col col-12 col-sm-2">
                                    <div class="row plain-element">
                                        <div class="input-field  col col-12 col-sm-12 col-md-2 col-lg-2">
                                            <label class="label-search opp-abb-lg">SEU:</label>
                                        </div>
                                        <div class="input-field  col col-12 col-sm-12 col-md-8 col-lg-8">
                                            <select v-model="seu" name="seu" id="seu" class="modal-select">
                                                <option value="" selected> All SEUs</option>
                                                <option v-for="(element, index) in getSelectMenus().seus" :key="index">
                                                    {{ element }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col col-12 col-sm-2">
                                    <div class="row plain-element">
                                        <div class="input-field  col col-12 col-sm-12 col-md-2 col-lg-2">
                                            <label class="label-search opp-abb-lg">Search:</label>
                                        </div>
                                        <div class="input-field  col col-12 col-sm-12 col-md-10 col-lg-10">
                                            <input class="form-control" id="keyWordSearchbox" type="text" placeholder="e.g. Steam"
                                                   aria-label="e.g. Steam" v-model="search" style="height: 32px; width: 96%">
                                        </div>
                                    </div>
                                </div>
                                <div class="col col-12 col-sm-2 text-end">
                                    <button type="button" class="btn btn-execute background-light-purple" @click="clearPrimarySelection()">Clear Selection</button>
                                </div>
                                <div class="col col-12 col-sm-2 text-end">
                                    <button type="button" class="btn btn-execute background-light-red" @click="goToCreateEnPI()">Missing EnPI?</button>
                                </div>
                                <div class="col col-12 col-sm-2 text-end">
                                    <button type="button" class="btn btn-execute" data-bs-dismiss="modal">Submit</button>
                                </div>
                            </div>
                        </div>
                        <div class="modal-body" style="white-space: pre-wrap; text-align: left;">
                            <div v-if="getSelectMenus().enpi_meters.length > 0" class="row plain-element">
                                <div v-for="element, index in primaryKeywordFilteredList" class="col col-12 col-sm-12 col-md-3 col-lg-3 plain-element" :key="index">
                                    <div class="input-field col col-12 col-sm-12 col-form">
                                        <label>
                                            <input type="checkbox" :value="element.name" v-model="selectedMetersPrimary" style="position: relative; top: 1px;">
                                            <span style="font-size: 14px;">{{  truncatechars(element.name,45) }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="row plain-element text-center">
                                <span style="font-size: 18px;">No {{ site }} EnPI Meters in database yet.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="secondarySelectionModal" tabindex="-1" aria-label="secondarySelectionModalLabel" aria-hidden="true">
                <div class="modal-dialog" style="max-width: 96%;">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="row plain-element" style="width: 100%;">
                                <div class="col col-12 col-sm-2">
                                    <div class="row plain-element">
                                        <div class="input-field  col col-12 col-sm-12 col-md-2 col-lg-2">
                                            <label class="label-search opp-abb-lg">Area:</label>
                                        </div>
                                        <div class="input-field  col col-12 col-sm-12 col-md-8 col-lg-8">
                                            <select v-model="areaSecondary" name="areaSecondary" id="areaSecondary" @change="clearSearchSecondary()" class="modal-select">
                                                <option value="" selected> All Areas</option>
                                                <option v-for="(element, index) in getSelectMenus().areas" :key="index">
                                                    {{ element }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="col col-12 col-sm-2">
                                    <div class="row plain-element">
                                        <div class="input-field  col col-12 col-sm-12 col-md-2 col-lg-2">
                                            <label class="label-search opp-abb-lg">SEU:</label>
                                        </div>
                                        <div class="input-field  col col-12 col-sm-12 col-md-8 col-lg-8">
                                            <select v-model="seuSecondary" name="seuSecondary" id="seuSecondary" class="modal-select">
                                                <option value="" selected> All SEUs</option>
                                                <option v-for="(element, index) in getSelectMenus().seus" :key="index">
                                                    {{ element }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col col-12 col-sm-3">
                                    <div class="row plain-element">
                                        <div class="input-field  col col-12 col-sm-12 col-md-2 col-lg-2">
                                            <label class="label-search opp-abb-lg">Search:</label>
                                        </div>
                                        <div class="input-field  col col-12 col-sm-12 col-md-10 col-lg-10">
                                            <input class="form-control" id="keyWordSearchbox" type="text" placeholder="e.g. Steam"
                                                   aria-label="e.g. Steam" v-model="searchSecondary" style="height: 32px; width: 96%">
                                        </div>
                                    </div>
                                </div>
                                <div class="col col-12 col-sm-5 text-end">
                                    <button type="button" class="btn btn-execute" data-bs-dismiss="modal">Submit</button>
                                </div>
                            </div>
                        </div>
                        <div class="modal-body" style="white-space: pre-wrap; text-align: left;">
                            <div v-if="getSelectMenus().enpi_meters.length > 0" class="row plain-element">
                                <div v-for="element in secondaryKeywordFilteredList" class="col col-12 col-sm-12 col-md-3 col-lg-3 plain-element" :key="element.name">
                                    <div class="input-field col col-12 col-sm-12 col-form">
                                        <label>
                                            <input type="radio" style="position: relative; top: 1px;" :value="element.name" v-model="selectedSecondaryMeter">
                                            <span style="margin-left: 4px; font-size: 14px;">{{  truncatechars(element.name,45) }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="row plain-element text-center">
                                <span style="font-size: 18px;">No {{ site }} EnPI Meters in database yet.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row row-cards">
                <div class="row text-start row-back">
                    <a href="/energyeye-select">
                        <span class="material-icons chevron-left">chevron_left</span> Back To Selection
                    </a>
                </div>
            </div>
            <div class="row row-break"></div>
            <div class="plain-element text-center hidden">
                <span class="font-red"> We're working on an alternative to Energy Eye that doesn't rely on Power BI. It's still a work in progress, and we welcome any suggestions.</span>
                <div class="row row-break"></div>
            </div>
            <div v-if="getUsername()" class="dashboard" v-cloak>
                <div class="plain-element text-center">
                    <div class="row row-opportunities row-energy-eye row-96">
                        <div class=" col col-12 col-sm-12 col-md-2 col-lg-3 plain-element">
                            <div class="row plain-element">
                                <div class=" col col-12 col-sm-12 col-md-6 col-lg-5 plain-element">
                                    <div class="input-field  col col-12 col-sm-12 col-md-10 col-lg-10 col-form">
                                        <div class="row plain-element text-start">
                                            <label class="label-search">Start Date</label>
                                        </div>
                                        <VueDatePicker
                                            v-model="start_date"
                                            :format="formatDate"
                                            :autoApply="true"
                                            :enableTimePicker="false"
                                            timezone="utc"
                                            @update:model-value="handleDateChange"
                                            required>
                                        </VueDatePicker>
                                    </div>
                                </div>
                                <div class=" col col-12 col-sm-12 col-md-6 col-lg-5 plain-element">
                                    <div class="input-field  col col-12 col-sm-12 col-md-10 col-lg-10 col-form">
                                        <div class="row plain-element text-start">
                                            <label class="label-search">End Date</label>
                                        </div>
                                        <VueDatePicker
                                            v-model="end_date"
                                            :format="formatDate"
                                            :autoApply="true"
                                            :enableTimePicker="false"
                                            timezone="utc"
                                            @update:model-value="handleDateChange2"
                                        required>
                                        </VueDatePicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class=" col col-12 col-sm-12 col-md-2 col-lg-9 plain-element">
                            <div class="row plain-element">
                                <div class=" col col-12 col-sm-12 col-md-2 col-lg-2 plain-element">
                                    <div class="input-field  col col-12 col-sm-12 col-md-11 col-lg-11 col-form">
                                        <div class="row plain-element text-start">
                                            <label class="label-search">Interval</label>
                                        </div>
                                        <select v-model="interval" name="interval" id="interval">
                                            <option v-for="element, index in getSelectMenus().intervals" :value="element" :key="index"> {{element}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class=" col col-12 col-sm-12 col-md-2 col-lg-3 plain-element">
                                    <div class="input-field  col col-12 col-sm-12 col-md-11 col-form">
                                        <div class="row plain-element text-start">
                                            <label class="label-search opp-abb-lg">Primary Selection</label>
                                            <label class="label-search opp-abb-md">Prim. Selection</label>
                                        </div>
                                        <div class="btn-modal" data-bs-toggle="modal" data-bs-target="#primarySelectionModal">
                                            <span v-if="selectedMetersPrimary.length > 0">{{ arrayToString(selectedMetersPrimary) }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="secondarySelection" class=" col col-12 col-sm-12 col-md-2 col-lg-3 plain-element">
                                    <div class="input-field  col col-12 col-sm-12 col-md-11 col-form">
                                        <div class="row plain-element text-start">
                                            <label class="label-search opp-abb-lg">Secondary Selection</label>
                                            <label class="label-search opp-abb-md">Sec. Selection</label>
                                        </div>
                                        <div class="btn-modal" data-bs-toggle="modal" data-bs-target="#secondarySelectionModal">
                                            <span v-if="selectedSecondaryMeter.length > 0">{{ selectedSecondaryMeter }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class=" col col-12 col-sm-12 col-md-2 col-lg-3 plain-element text-start">
                                    <button v-if="!secondarySelection" class="btn btn-powerbi btn-energy-eye" @click="toggleSecondarySelection()">
                                        Add Secondary Selection
                                    </button>
                                    <button v-else class="btn btn-powerbi background-light-purple btn-energy-eye" @click="toggleSecondarySelection()">
                                        Remove Secondary Selection
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row row-break"></div>
                    <div v-if="!getLoader() && selectedMetersPrimary.length > 0" class="row row-opportunities row-96">
                        <div class=" col col-12 col-sm-12 col-md-3 col-lg-3 plain-element text-start">
                            <button class="btn btn-execute" @click="executeQuery()">
                                Load Data
                            </button>
                        </div>
                    </div>
                    <div v-if="!getLoader() && selectedMetersPrimary.length == 0" class="row row-opportunities row-96">
                        <div class=" col col-12 col-sm-12 col-md-12 col-lg-12 plain-element text-start">
                            <p>
                                Select Meter
                            </p>
                        </div>
                    </div>
                    <div v-if="getLoader()" class="loader" id="loader"></div>
                    <div class="row row-break"></div>
                    <p class="error" v-if="getFormError()">
                        <span id="formError">{{ getFormError() }}</span>
                    </p>
                    <div v-if="queryExecuted && !getLoader() && !getFormError()" class="row row-opportunities row-96">
                        <div class="col col-4 col-sm-4 col-md-10 col-lg-10 plain-element text-start">
                            <div class="row plain-element">
                                <div class=" col col-4 col-sm-4 col-md-3 col-lg-2 plain-element text-start">
                                    <div class="btn-plans-tab-secondary" @click="activateChartTab('area')">
                                        <div v-if="chart_tab === 'area'" class="tab-plans-active">
                                          <span class="material-icons icon-chart">area_chart</span>Area Chart
                                        </div>
                                        <div v-else>
                                        <span class="material-icons icon-chart">area_chart</span>Area Chart
                                        </div>
                                    </div>
                                </div>
                                <div class=" col col-4 col-sm-4 col-md-3 col-lg-2 plain-element text-start">
                                    <div class="btn-plans-tab-secondary" @click="activateChartTab('bar')">
                                        <div v-if="chart_tab === 'bar'" class="tab-plans-active">
                                          <span class="material-icons icon-chart">bar_chart</span>Bar Chart
                                        </div>
                                        <div v-else>
                                          <span class="material-icons icon-chart">bar_chart</span>Bar Chart
                                        </div>
                                    </div>
                                </div>
                                <div class=" col col-4 col-sm-4 col-md-3 col-lg-2 plain-element text-start">
                                    <div class="btn-plans-tab-secondary" @click="activateChartTab('distribution')">
                                        <div v-if="chart_tab === 'distribution'" class="tab-plans-active">
                                          <span class="material-icons icon-chart">donut_small</span>Distribution
                                        </div>
                                        <div v-else>
                                          <span class="material-icons icon-chart">donut_small</span>Distribution
                                        </div>
                                    </div>
                                </div>
                                <div v-if="getRelatedActions()" class=" col col-4 col-sm-4 col-md-3 col-lg-2 plain-element text-start">
                                    <div class="btn-plans-tab-secondary" @click="activateChartTab('related_actions')">
                                        <div v-if="chart_tab === 'related_actions'" class="tab-plans-active">
                                          <span class="material-icons icon-chart">lightbulb</span>Related Actions
                                        </div>
                                        <div v-else>
                                          <span class="material-icons icon-chart animate-character">lightbulb</span>Related Actions
                                        </div>
                                    </div>
                                </div>
                                <div class=" col col-4 col-sm-4 col-md-3 col-lg-2 plain-element text-start">
                                    <div class="btn-plans-tab-secondary" @click="activateChartTab('stats')">
                                        <div v-if="chart_tab === 'stats'" class="tab-plans-active">
                                          <span class="material-icons icon-chart">percent</span>Statistics
                                        </div>
                                        <div v-else>
                                          <span class="material-icons icon-chart">percent</span>Statistics
                                        </div>
                                    </div>
                                </div>
                                <div class=" col col-4 col-sm-4 col-md-3 col-lg-2 plain-element text-start">
                                    <div class="btn-plans-tab-secondary" @click="activateChartTab('download')">
                                        <div v-if="chart_tab === 'download'" class="tab-plans-active">
                                          <span class="material-icons icon-chart">download</span>Download Data
                                        </div>
                                        <div v-else>
                                          <span class="material-icons icon-chart">download</span>Download Data
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row row-break"></div>
                    <div v-if="getAreaGraphData() && !getLoader() && (chart_tab === 'area' || chart_tab === 'bar')" class="row row-opportunities row-96">
                        <div class="col col-sm-4 col-md-4 col-lg-2 plain-element">
                            <div class="row plain-element">
                                <div class="input-field col col-12 col-sm-12 col-md-12 col-lg-9 text-start" style="display: flex; align-items: center;">
                                    <label class="label-search" style="padding-right: 12px; white-space: nowrap;">Y-Min:</label>
                                    <input id="change" type="number" name="change" min="-1000000" max="1000000" step="1" v-model="ymin" class="validate" @change="updateCharts()">
                                </div>
                            </div>
                        </div>
                        <div class="col col-sm-4 col-md-4 col-lg-2 plain-element">
                            <div class="row plain-element">
                                <div class="input-field col col-12 col-sm-12 col-md-12 col-lg-9 text-start" style="display: flex; align-items: center;">
                                    <label class="label-search" style="padding-right: 12px; white-space: nowrap;">Y-Max:</label>
                                    <input id="change" type="number" name="change" min="-1000000" max="1000000" step="1" v-model="ymax" class="validate" @change="updateCharts()">
                                </div>
                            </div>
                        </div>
                        <div class="col col-sm-4 col-md-3 col-lg-3 plain-element">
                            <button class="btn btn-execute background-light-purple" @click="resetAxis()">Reset Axis</button>
                        </div>
                        <div class="col col-sm-4 col-md-4 col-lg-1 plain-element"></div>
                        <div v-if="getSecondaryAxis()" class="col col-sm-4 col-md-4 col-lg-2 plain-element">
                            <div class="row plain-element">
                                <div class="input-field col col-12 col-sm-12 col-md-12 col-lg-9 text-start" style="display: flex; align-items: center;">
                                    <label class="label-search" style="padding-right: 12px; white-space: nowrap;">Sec. Y-Min:</label>
                                    <input id="change" type="number" name="change" min="-1000000" max="1000000" step="1" v-model="sec_ymin" class="validate" @change="updateCharts()">
                                </div>
                            </div>
                        </div>
                        <div v-if="getSecondaryAxis()" class="col col-sm-4 col-md-4 col-lg-2 plain-element">
                            <div class="row plain-element">
                                <div class="input-field col col-12 col-sm-12 col-md-12 col-lg-9 text-start" style="display: flex; align-items: center;">
                                    <label class="label-search" style="padding-right: 12px; white-space: nowrap;">Sec. Y-Max:</label>
                                    <input id="change" type="number" name="change" min="-1000000" max="1000000" step="1" v-model="sec_ymax" class="validate" @change="updateCharts()">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="getAreaGraphData()" class="row plain-element text-center">
                        <div v-if="getAreaGraphData().chartUnits" class="row plain-element text-center">
                            <div v-if="getAreaGraphData().chartUnits.includes(',')" class="row plain-element text-center" >
                                    <div style="padding: 24px 0px 0px 0px; color: #e7787a;">Multiple units selected on same axis</div>
                            </div>
                        </div>
                    </div>
                    <div v-if="getAreaGraphData() && getBarGraphData()" class="row row-opportunities row-96">
                        <div class="row row-break"></div>
                        <div v-if="chart_tab === 'area'" class=" col col-12 col-sm-12 col-md-12 col-lg-12 plain-element text-start">
                            <div v-if="getSecondaryAxis()" class="chart">
                                <energy-eye-area-chart-dual
                                ref="areaChartDual"
                                :key="chart_tab"
                                :chart-data="{ ...getAreaGraphData(), ymin: ymin, ymax: ymax, sec_ymin: sec_ymin, sec_ymax: sec_ymax }"
                                :styles="energyEyeChartStyles"
                                :chartInterval="getAreaGraphData().chartInterval"
                                :chartUnits="getAreaGraphData().chartUnits"
                                :secondaryChartUnits="getAreaGraphData().secondaryChartUnits"
                                :timeLabels="getAreaGraphData().time_labels"

                                style="min-height: 480px; margin-bottom: 60px;"></energy-eye-area-chart-dual>
                            </div>
                            <div v-else class="chart">
                                <energy-eye-area-chart
                                ref="areaChart"
                                :key="chart_tab"
                                :chart-data="{ ...getAreaGraphData(), ymin: ymin, ymax: ymax }"
                                :styles="energyEyeChartStyles"
                                :chartInterval="getAreaGraphData().chartInterval"
                                :chartUnits="getAreaGraphData().chartUnits"
                                :secondaryChartUnits="getAreaGraphData().secondaryChartUnits"
                                :timeLabels="getAreaGraphData().time_labels"

                                style="min-height: 480px; margin-bottom: 60px;"></energy-eye-area-chart>
                            </div>
                        </div>
                        <div v-if="chart_tab === 'bar'" class=" col col-12 col-sm-12 col-md-12 col-lg-12 plain-element text-start">
                            <div v-if="getSecondaryAxis()" class="chart">
                                <energy-eye-bar-chart-dual
                                ref="barChartDual"
                                :key="chart_tab"
                                :chart-data="getBarGraphData()"
                                :styles="energyEyeChartStyles"
                                :chartInterval="getAreaGraphData().chartInterval"
                                :chartUnits="getAreaGraphData().chartUnits"
                                :secondaryChartUnits="getAreaGraphData().secondaryChartUnits"
                                :timeLabels="getBarGraphData().time_labels"

                                style="min-height: 480px; margin-bottom: 60px;"></energy-eye-bar-chart-dual>
                            </div>
                            <div v-else class="chart">
                                <energy-eye-bar-chart
                                ref="barChart"
                                :key="chart_tab"
                                :chart-data="{ ...getBarGraphData(), ymin: ymin, ymax: ymax }"
                                :styles="energyEyeChartStyles"
                                :chartInterval="getBarGraphData().chartInterval"
                                :chartUnits="getBarGraphData().chartUnits"
                                :secondaryChartUnits="getBarGraphData().secondaryChartUnits"
                                :timeLabels="getBarGraphData().time_labels"

                                style="min-height: 480px; margin-bottom: 60px;"></energy-eye-bar-chart>
                            </div>
                        </div>
                        <div v-if="chart_tab === 'distribution'" class=" col col-12 col-sm-12 col-md-6 col-lg-6 plain-element text-start">
                            <div class="chart">
                                <energy-eye-distribution-chart
                                :chart-data="getDistributionGraphData()"
                                :styles="energyEyeChartStyles"
                                :chartUnits="getAreaGraphData().chartUnits"
                                :secondaryChartUnits="getAreaGraphData().secondaryChartUnits"

                                style="min-height: 480px; margin-bottom: 60px;"></energy-eye-distribution-chart>
                            </div>
                        </div>
                        <div v-if="chart_tab === 'related_actions' && getRelatedActions()" class=" col col-12 col-sm-12 col-md-12 col-lg-12 plain-element text-start">
                            <table id="searchTable">
                              <thead>
                                <tr>
                                  <th>Action No.
                                  </th>
                                  <th class="text-start">Status
                                  </th>
                                  <th class="text-start">Created
                                  </th>
                                  <th class="text-start">Site Code
                                  </th>
                                  <th class="text-start">SEU
                                  </th>
                                  <th class="text-start">Event Type
                                  </th>
                                  <th class="text-center th-description">Comment</th>
                                  <th class="text-center th-description">Response</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="action in getRelatedActions()" :key="action.id" @click="goToActionView(action.id.toString())">
                                  <td class="text-start field-opportunity">
                                    <span>{{action.action_number}}</span>
                                  </td>
                                  <td class="text-start field-number">{{action.status}}</td>
                                  <td class="text-start field-number">{{action.created_date}}</td>
                                  <td class="text-start field-number">{{action.site_code__site_code}}</td>
                                  <td class="text-start field-number">{{action.seu__seu}}</td>
                                  <td class="text-start field-opportunity">{{action.event_type__event_type}}</td>
                                  <td class="text-start field-description" style="padding-right: 12px;">{{ truncatechars(replaceNewlines(action.comment), 300) }}</td>
                                  <td class="text-start field-description">{{ truncatechars(replaceNewlines(action.response), 300) }}</td>
                                </tr>
                              </tbody>
                            </table>
                        </div>
                        <div v-if="chart_tab === 'stats' && getStatisticalData()" class=" col col-12 col-sm-12 col-md-12 col-lg-12 plain-element text-start">
                            <div class="row  plain-element text-start">
                                <div class=" col col-12 col-sm-12 col-md-6 col-lg-6 plain-element text-start">
                                    <div class="row  plain-element text-start">
                                        <div class=" col col-12 col-sm-12 col-md-10 col-lg-10 plain-element text-start">
                                            <table class="table-metrics table-metadata">
                                                <tbody>
                                                <tr>
                                                    <th>Primary Selection</th>
                                                    <th class="text-end">Sum</th>
                                                    <th class="text-end">Mean</th>
                                                    <th class="text-end">Median</th>
                                                    <th class="text-end">St Dev</th>
                                                    <th class="text-end">Min</th>
                                                    <th class="text-end">Max</th>
                                                    <th class="text-end">%</th>
                                                </tr>
                                                <tr v-for="element, index in selectedMetersPrimary" :key="index">
                                                    <td style="font-size: 14px; padding: 4px; color: #0b5cfc;">{{ element }}</td>
                                                    <td class="text-end" style="font-size: 14px; padding: 4px;">{{ (getStatisticalData()[element].sum).toLocaleString()}}</td>
                                                    <td class="text-end" style="font-size: 14px; padding: 4px;">{{ (getStatisticalData()[element].mean).toLocaleString() }}</td>
                                                    <td class="text-end" style="font-size: 14px; padding: 4px;">{{ (getStatisticalData()[element].median).toLocaleString() }}</td>
                                                    <td class="text-end" style="font-size: 14px; padding: 4px;">{{ (getStatisticalData()[element].std_dev).toLocaleString() }}</td>
                                                    <td class="text-end" style="font-size: 14px; padding: 4px;">{{ (getStatisticalData()[element].min).toLocaleString() }}</td>
                                                    <td class="text-end" style="font-size: 14px; padding: 4px;">{{ (getStatisticalData()[element].max).toLocaleString() }}</td>
                                                    <td class="text-end" style="font-size: 14px; padding: 4px;">{{ getStatisticalData()[element].percentage }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="text-end" style="font-size: 14px; padding: 4px; font-weight: 500;">Total:</td>
                                                    <td class="text-end" style="font-size: 14px; padding: 4px; font-weight: 500;">{{ (getStatisticalData()["Total"].sum).toLocaleString() }}</td>
                                                    <td class="text-end" style="font-size: 14px; padding: 4px; font-weight: 500;">{{ (getStatisticalData()["Total"].mean).toLocaleString() }}</td>
                                                    <td class="text-end" style="font-size: 14px; padding: 4px; font-weight: 500;">{{ (getStatisticalData()["Total"].median).toLocaleString() }}</td>
                                                    <td class="text-end" style="font-size: 14px; padding: 4px; font-weight: 500;">{{ (getStatisticalData()["Total"].std_dev).toLocaleString() }}</td>
                                                    <td class="text-end" style="font-size: 14px; padding: 4px; font-weight: 500;">{{ (getStatisticalData()["Total"].min).toLocaleString() }}</td>
                                                    <td class="text-end" style="font-size: 14px; padding: 4px; font-weight: 500;">{{ (getStatisticalData()["Total"].max).toLocaleString() }}</td>
                                                    <td class="text-end" style="font-size: 14px; padding: 4px; font-weight: 500;">{{ getStatisticalData()["Total"].percentage }}</td>
                                                </tr>
                                                </tbody>
                                            </table>

                                        </div>
                                    </div>
                                </div>
                                <div class=" col col-12 col-sm-12 col-md-6 col-lg-6 plain-element text-start">
                                    <div class="row  plain-element text-start">
                                        <div class=" col col-12 col-sm-12 col-md-10 col-lg-10 plain-element text-start">
                                            <div v-if="selectedSecondaryMeter.length > 0" class="row  plain-element text-start">
                                                <table class="table-metrics table-metadata">
                                                    <tbody>
                                                    <tr>
                                                        <th>Secondary Selection</th>
                                                        <th class="text-end">Sum</th>
                                                        <th class="text-end">Mean</th>
                                                        <th class="text-end">Median</th>
                                                        <th class="text-end">St Dev</th>
                                                        <th class="text-end">Min</th>
                                                        <th class="text-end">Max</th>
                                                        <th class="text-end">%</th>
                                                    </tr>
                                                    <tr>
                                                        <td style="font-size: 14px; padding: 4px; color: #5d4bc2;">{{ selectedSecondaryMeter }}</td>
                                                        <td class="text-end" style="font-size: 14px; padding: 4px;">{{ (getStatisticalData()[selectedSecondaryMeter].sum).toLocaleString() }}</td>
                                                        <td class="text-end" style="font-size: 14px; padding: 4px;">{{ (getStatisticalData()[selectedSecondaryMeter].mean).toLocaleString() }}</td>
                                                        <td class="text-end" style="font-size: 14px; padding: 4px;">{{ (getStatisticalData()[selectedSecondaryMeter].median).toLocaleString() }}</td>
                                                        <td class="text-end" style="font-size: 14px; padding: 4px;">{{ (getStatisticalData()[selectedSecondaryMeter].std_dev).toLocaleString() }}</td>
                                                        <td class="text-end" style="font-size: 14px; padding: 4px;">{{ (getStatisticalData()[selectedSecondaryMeter].min).toLocaleString() }}</td>
                                                        <td class="text-end" style="font-size: 14px; padding: 4px;">{{ (getStatisticalData()[selectedSecondaryMeter].max).toLocaleString() }}</td>
                                                        <td class="text-end" style="font-size: 14px; padding: 4px;">{{ getStatisticalData()[selectedSecondaryMeter].percentage }}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="chart_tab === 'download' && !getLoader()" class=" col col-12 col-sm-12 col-md-6 col-lg-6 plain-element text-start">
                            <div class="row  plain-element text-start">
                                <div class=" col col-12 col-sm-12 col-md-4 col-lg-4 plain-element text-start">
                                    <div class="card card-menu"  @click="downloadExcelQuery()">
                                        <div class="card-image">
                                          <img class="img-menu" src="https://saperapublicstorage.blob.core.windows.net/static/img/icons/excel.png" alt="Logo"/>
                                        </div>
                                        <div class="card-content">
                                          <span class="card-title">Download Excel</span>
                                        </div>
                                    </div>
                                </div>
                                <div class=" col col-12 col-sm-12 col-md-4 col-lg-4 plain-element text-start">
                                    <div class="card card-menu"  @click="downloadCsvQuery()">
                                        <div class="card-image">
                                          <img class="img-menu" src="https://saperapublicstorage.blob.core.windows.net/static/img/icons/csv.png" alt="Logo"/>
                                        </div>
                                        <div class="card-content">
                                          <span class="card-title">Download CSV</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import VueDatePicker from '@vuepic/vue-datepicker';

import NoPermissionComponent from "@/components/NoPermissionComponent.vue";
import EnergyEyeAreaChart from "@/common/graphs/energy_eye/EnergyEyeAreaChart.js";
import EnergyEyeBarChart from "@/common/graphs/energy_eye/EnergyEyeBarChart.js";
import EnergyEyeAreaChartDual from "@/common/graphs/energy_eye/EnergyEyeAreaChartDual.js";
import EnergyEyeBarChartDual from "@/common/graphs/energy_eye/EnergyEyeBarChartDual.js";
import EnergyEyeDistributionChart from "@/common/graphs/energy_eye/EnergyEyeDistributionChart.js";
import { truncatechars } from "@/common/general.js";

export default {
  name: "EnergyEyeView",
  components: {
    NoPermissionComponent,
    VueDatePicker,
    EnergyEyeAreaChart,
    EnergyEyeBarChart,
    EnergyEyeAreaChartDual,
    EnergyEyeBarChartDual,
    EnergyEyeDistributionChart,
  },
  props: {
    site: {
      type: String,
      required: true,
    },
  },
  data() {
    // Get the current date (end_date)
    const currentDate = new Date();
    // Calculate the date 60 days ago (start_date)
    const pastDate = new Date();
    pastDate.setDate(currentDate.getDate() - 60);

    return {
      dateFormat: 'yyyy-MM-dd',
      ymin: 0,
      sec_ymin: 0,
      area: "",
      seu: "",
      areaSecondary: "",
      seuSecondary: "",
      query: "",
      selectedMetersPrimary: [],
      selectedSecondaryMeter: "",
      queryExecuted: false,
      search: "",
      searchSecondary: "",
      year: pastDate.getFullYear(), // Automatically setting the year to pastDate's year
      month: pastDate.getMonth() + 1, // Automatically setting the month to pastDate's month
      interval: "Hourly",
      start_date: pastDate.toISOString().split('T')[0],
      end_date: currentDate.toISOString().split('T')[0],
      primary_selection: "test",
      secondarySelection: false,
      chart_tab: "area",
    };
  },

  methods: {
    ...mapGetters([
      "getUsername", "isLoggedIn", "getSelectMenus", "getAreaGraphData",
      "getBarGraphData", "getLoader", "getStatisticalData",
      "getDistributionGraphData", "getFormError", "getSecondaryAxis", "getRelatedActions",
    ]),
    ...mapActions([
      "performSetFormError", "fetchSelectMenus", "performExecuteEnergyEyeQuery",
      "performCreateEnergyEyeRecentQuery", "performDownloadEnergyEyeExcelQuery",
      "performDownloadEnergyEyeCsvQuery", "updateEnergyEyeCharts"
    ]),
// STRINGS AND ARRAYS
    truncatechars: truncatechars,
    arrayToString(arr) {
        let str = arr.slice(0, 4).join(', ');

        // Check if the string length exceeds 40 characters
        if (str.length > 40) {
            // Cut the string and add "..."
            str = str.substring(0, 40) + "...";
        }

        return str;
    },

    metersToArray(meterString) {
      // Remove brackets and single quotes, then split by comma
        return meterString
        .replace(/[[\]']/g, '') // Remove [ ] and '
        .split(',')
        .map(item => item.trim()); // Trim whitespace from each item
    },

// GRAPHS
    updateCharts() {
      if (this.getAreaGraphData() && this.getBarGraphData()) {
        this.updateEnergyEyeCharts({
            "area_dataset": this.getAreaGraphData(),
            "bar_dataset": this.getBarGraphData(),
            "ymin": this.ymin,
            "ymax": this.ymax,
            "sec_ymin": this.sec_ymin,
            "sec_ymax": this.sec_ymax,
        });
      } else {
        console.error("Graph data is not available");
      }
      this.updateChartAxis();
    },

    resetAxis() {
      this.ymax = null;
      this.ymin = 0;
      this.sec_ymin = 0;
      this.sec_ymax = 0;
      this.updateChartAxis();
    },

    updateChartAxis() {
      this.$nextTick(() => {
        const updateChart = (chartRef) => {
          if (chartRef && chartRef.$data && chartRef.$data._chart) {
            const chart = chartRef.$data._chart;
            chart.options.scales.y.min = parseInt(this.ymin) || 0;
            chart.options.scales.y.max = this.ymax !== null ? parseInt(this.ymax) : undefined;

            if (chart.options.scales.y1) {
              if (this.sec_ymin !== null) {
                chart.options.scales.y1.min = parseInt(this.sec_ymin);
              }
              if (this.sec_ymax !== null) {
                chart.options.scales.y1.max = parseInt(this.sec_ymax);
              }
            }
            chart.update();
          }
        };

        updateChart(this.$refs.areaChart);
        updateChart(this.$refs.barChart);
        updateChart(this.$refs.areaChartDual);
        updateChart(this.$refs.barChartDual);
      });
    },

//  NAVIGATION & BUTTONS
    goToCreateEnPI() {
        window.open(`/enpi-search/${this.site}`, '_blank');
    },
    activateChartTab(tabName) {
      this.chart_tab = tabName;
      this.updateCharts();
    },
    toggleSecondarySelection() {
      this.secondarySelection = !this.secondarySelection;
      if (!this.secondarySelection) {
        this.selectedSecondaryMeter = "";
      }
    },
    clearPrimarySelection() {
      this.selectedMetersPrimary = [];
    },
    clearSearch() {
      this.search = "";
      this.seu = "";
    },
    clearSearchSecondary() {
      this.searchSecondary = "";
      this.seuSecondary = "";
    },

// QUERIES
    executeQuery() {
      const totalMetersSelected = this.selectedMetersPrimary.length;

      if (!this.start_date) {
        this.query = "Please select a start date.";
        return;
      }

      if (!this.end_date) {
        this.query = "Please select a end date.";
        return;
      }

      console.log('Current Time Zone:', Intl.DateTimeFormat().resolvedOptions().timeZone);

      this.ymin = 0;
      this.sec_ymin = 0;
      this.ymax = null;
      this.sec_ymax = null;

      if (totalMetersSelected > 20) {
        this.query = "Selection limit exceeded. Only 20 meters are allowed.";
      } else if (this.selectedMetersPrimary.length > 0) {
        this.query = `Retrieving range of ${this.interval} data between ${this.start_date} AND ${this.end_date} for Primary meters: ${this.selectedMetersPrimary} AND secondary meters: ${this.selectedSecondaryMeter}`;
        console.log(this.query)
        this.performExecuteEnergyEyeQuery({
          "site_code": this.site,
          "primary_meters": this.selectedMetersPrimary,
          "secondary_meter": this.selectedSecondaryMeter,
          "start_date": this.start_date,
          "end_date": this.end_date,
          "interval": this.interval
        });
        this.performCreateEnergyEyeRecentQuery({
          "site_code": this.site,
          "primary_meters": this.selectedMetersPrimary,
          "secondary_meter": this.selectedSecondaryMeter,
          "start_date": this.start_date,
          "end_date": this.end_date,
          "interval": this.interval,
          "query_date": this.getFormattedCurrentDateTime(),
          "user": this.getUsername(),
        });
        this.queryExecuted = true;
      } else {
        this.query = "Select Meters First";
      }
    },

    downloadExcelQuery() {
      const totalMetersSelected = this.selectedMetersPrimary.length;
      if (totalMetersSelected > 20) {
        this.query = "Selection limit exceeded. Only 20 meters are allowed.";
      } else if (this.selectedMetersPrimary.length > 0) {
        this.query = "Retrieving range of " + this.interval + " data between " + this.start_date + " AND " + this.end_date + " for Primary meters: " + this.selectedMetersPrimary + " AND secondary meters: " + this.selectedSecondaryMeter;
        this.performDownloadEnergyEyeExcelQuery({
          "site_code": this.site,
          "primary_meters": this.selectedMetersPrimary,
          "secondary_meter": this.selectedSecondaryMeter,
          "start_date": this.start_date,
          "end_date": this.end_date,
          "interval": this.interval
        });
        this.queryExecuted = true;
      } else {
        this.query = "Select Meters First";
      }
    },

    downloadCsvQuery() {
      const totalMetersSelected = this.selectedMetersPrimary.length;
      if (totalMetersSelected > 20) {
        this.query = "Selection limit exceeded. Only 20 meters are allowed.";
      } else if (this.selectedMetersPrimary.length > 0) {
        this.query = "Retrieving range of " + this.interval + " data between " + this.start_date + " AND " + this.end_date + " for Primary meters: " + this.selectedMetersPrimary + " AND secondary meters: " + this.selectedSecondaryMeter;
        this.performDownloadEnergyEyeCsvQuery({
          "site_code": this.site,
          "primary_meters": this.selectedMetersPrimary,
          "secondary_meter": this.selectedSecondaryMeter,
          "start_date": this.start_date,
          "end_date": this.end_date,
          "interval": this.interval
        });
        this.queryExecuted = true;
      } else {
        this.query = "Select Meters First";
      }
    },

// DATES

    getFormattedCurrentDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    customFormatter(date) {
      return date.toISOString().split("T")[0];
    },
    formatDate(date) {
        // Get the current timezone
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        // Check if the timezone is in Europe
        if (timeZone.startsWith('Europe/')) {
            // Adjust for local timezone and format the date
            const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
            return localDate.toISOString().split('T')[0];
        }

        // Check if the timezone is in the US
        if (timeZone.startsWith('America/')) {
            // Return the date as an ISO string in UTC
            return date.toISOString().split('T')[0];
        }

        // Default return if neither condition is met (optional)
        return date.toISOString().split('T')[0]; // or handle default case differently if needed
    },

    handleDateChange(date) {
      if (date) {
        this.start_date = this.formatDate(date);
      } else {
        this.start_date = '';
      }
      console.log('Start Date changed:', this.start_date);
    },
    handleDateChange2(date) {
        if (date) {
            // Ensure the date is stored without time zone
          this.end_date = this.formatDate(date);
        } else {
          this.end_date = "";
        }
      console.log('End Date changed:', this.end_date);
    },
    replaceNewlines(comment) {
        // Return "-" if comment is null, undefined, or empty (after trimming)
        if (!comment || comment.trim() === '') {
            return '-';
        }

        // Replace newline characters with " | "
        return comment.replace(/\n/g, ' | ');
    },
    goToActionView(id) {
      if (event.ctrlKey === true) {
        window.open(`/action-details/${id}`, '_blank');
      } else {
        window.open(`/action-details/${id}`, '_blank');
      }
    },
  },
  computed: {
    ymax: {
      get() { return this.$store.getters.getYMax; },
      set(value) { this.$store.commit('setYMax', value); }
    },
    sec_ymax: {
      get() { return this.$store.getters.getSecYMax; },
      set(value) { this.$store.commit('setSecYMax', value); }
    },
    areaFilteredList() {
      return this.area !== ""
        ? this.getSelectMenus().enpi_meters.filter(meter => meter.area.includes(this.area))
        : this.getSelectMenus().enpi_meters;
    },
    seuFilteredList() {
      return this.seu !== ""
        ? this.areaFilteredList.filter(meter => meter.seu.includes(this.seu))
        : this.areaFilteredList;
    },
    primaryKeywordFilteredList() {
      return this.seuFilteredList.filter(meter => meter.name.toLowerCase().includes(this.search.toLowerCase()));
    },
    areaFilteredSecondaryList() {
      return this.areaSecondary !== ""
        ? this.getSelectMenus().enpi_meters.filter(meter => meter.area.includes(this.areaSecondary))
        : this.getSelectMenus().enpi_meters;
    },
    seuFilteredSecondaryList() {
      return this.seuSecondary !== ""
        ? this.areaFilteredSecondaryList.filter(meter => meter.seu.includes(this.seuSecondary))
        : this.areaFilteredSecondaryList;
    },
    secondaryKeywordFilteredList() {
      return this.seuFilteredSecondaryList.filter(meter => meter.name.toLowerCase().includes(this.searchSecondary.toLowerCase()));
    },
    energyEyeChartStyles() {
      return { position: "relative" };
    },
    date() {
      var d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-');
    },

    parseStartDate() {
      var d = this.start_date,
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;
      return year.toString() + "-" + month + "-" + day;
    },

    parseEndDate() {
      var d = this.end_date,
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;
      return year.toString() + "-" + month + "-" + day;
    },
  },
  watch: {
    ymin() {
      this.updateCharts();
    },
    ymax() {
      this.updateCharts();
    },
    sec_ymin() {
      this.updateCharts();
    },
    sec_ymax() {
      this.updateCharts();
    },
  },
  created() {
    document.title = "Energy Eye";
    this.performSetFormError(null);
    this.fetchSelectMenus(this.site);
    window.scrollTo(0, 0);
  }
};
</script>

